/** @module form */

/**
 * Initializes functionality for search inputs.
 * Should not be referenced directly.
 *
 * @param {NodeList} inputs
 * @private
 * @see {@link searchInput}
 */
export function initSearchInputs(inputs) {
    inputs.forEach((input) => {
        input.addEventListener('focus', ({ target }) => {
            target.select();
        });

        const clearButton = input.parentNode.querySelector(`[data-clear-input=${input.id}]`);

        if (clearButton) {
            input.addEventListener('input', ({ target }) => {
                clearButton.disabled = !target.value;
            });

            clearButton.addEventListener(
                'click',
                () => {
                    input.value = '';
                    input.dispatchEvent(new Event('input', { bubbles: true, cancelable: false }));

                    if ('submitOnClick' in clearButton.dataset) {
                        input.closest('form').dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                    }
                },
                { passive: true },
            );
        }
    });
}
